export default function getReaderByFile(file): Promise<FileReader | null> {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader);
    };
    reader.onerror = () => {
      resolve(null);
    };
  });
}
